import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#IconToggleFavoritesOff12a)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m6 2.917-.534 1.357c-.204.519-.685.88-1.245.928l-1.497.127 1.198 1.085c.395.357.566.9.449 1.418L4.02 9.38l1.182-.763a1.469 1.469 0 0 1 1.594 0l1.181.763-.35-1.55a1.475 1.475 0 0 1 .449-1.417l1.198-1.085-1.497-.127a1.471 1.471 0 0 1-1.244-.928L6 2.917ZM4.63.933C5.121-.31 6.88-.31 7.368.933l.907 2.304 2.377.201c1.29.11 1.81 1.703.862 2.561L9.647 7.69l.566 2.51c.288 1.273-1.112 2.286-2.231 1.564L6 10.484l-1.982 1.28c-1.12.722-2.52-.291-2.232-1.564l.566-2.51L.485 6c-.948-.859-.428-2.453.862-2.562l2.378-.201L4.63.933Z",
        fill: "currentColor"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "IconToggleFavoritesOff12a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        })
      })
    })]
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconToggleFavoritesOff12 = createIcon(IconComponent);